import { MailIcon } from "@heroicons/react/outline";
import { useRouter } from "next/router";
import { useState } from "react";
import toast from "react-hot-toast";
import {
  Analytics,
  EventAction,
  EventObject,
} from "services/analytics.service";
import { ApiService } from "services/api.service";
import { HUMANLOOP_APP_SIGNUP } from "utils/constants";
import Button from "../library/Button";
import { LoadingIcon } from "../library/Icons";
import { classNames } from "../library/utils/classNames";

const BUTTON_TEXT = "Get access now";

export const EmailForm = ({ shade }: { shade?: "blue" | "black" }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: "",
  });
  const router = useRouter();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    Analytics.identify(form.email, { email: form.email });
    Analytics.track(EventObject.Form, EventAction.Submitted, {
      form: "gpt3-interested",
      email: form.email,
    });
    const result = await ApiService.post(
      "/api/gpt3-signup",
      form,
      {},
      (e, method, url, data, config) => {
        const message = e?.response?.data?.message;
        console.log("Failed to fetch:", e, method, url, data, config);
        if (message) {
          toast.error(message);
        }
        setLoading(false);
      }
    );
    if (result.status === 200) {
      setTimeout(() => {
        router.push(HUMANLOOP_APP_SIGNUP + "?email=" + form.email);
      }, 500);
    }
  };

  return (
    <form id="main-cta" onSubmit={handleSubmit}>
      <div className="flex justify-center gap-12">
        {/* TODO: styling */}
        <div className="relative grow rounded">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-12">
            <MailIcon className="h-24 w-24 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="email"
            name="email"
            id="email"
            required
            className="form-input block h-[44px] w-full rounded border-[#757DF0] pl-48 pr-[140px] text-14-20 text-black ring-[3px] ring-blue-200 md:h-52 md:pr-0 md:text-16-24"
            placeholder="your email"
            value={form.email}
            onChange={(e) => {
              setForm({
                ...form,
                email: e.target.value,
              });
            }}
          />
          <div className="absolute inset-y-0 right-0 p-6 md:hidden">
            <Button
              type="submit"
              styling="solid"
              shade={"blue"}
              className={classNames(shade === "black" && "!bg-black")}
              size={32}
              loading={loading}
              IconRight={loading ? LoadingIcon : undefined}
            >
              {BUTTON_TEXT}
            </Button>
          </div>
        </div>
        <Button
          type="submit"
          styling="solid"
          shade={"blue"}
          className={classNames(
            shade === "black" && "!bg-black",
            "hidden md:flex ",
            loading ? "pl-32" : "px-32"
          )}
          loading={loading}
          IconRight={loading ? LoadingIcon : undefined}
          size={52}
        >
          {BUTTON_TEXT}
        </Button>
      </div>
    </form>
  );
};
